import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['step1', 'step2', 'btncontinue', 'btnsubmit', 'btncancel', 'btnbackstep1']

  hidestep1() {
    this.step1Target.classList.add('tw-hidden')
    this.btncontinueTarget.classList.add('tw-hidden')
    this.btncancelTarget.classList.add('tw-hidden')
    this.showstep2()
  }

  showstep1() {
    this.step1Target.classList.remove('tw-hidden')
    this.btncontinueTarget.classList.remove('tw-hidden')
    this.btncancelTarget.classList.remove('tw-hidden')
  }

  hidestep2() {
    this.step2Target.classList.add('tw-hidden')
    this.btnbackstep1Target.classList.add('tw-hidden')
    this.btnsubmitTarget.classList.add('tw-hidden')
    this.showstep1()
  }

  showstep2() {
    this.step2Target.classList.remove('tw-hidden')
    this.btnbackstep1Target.classList.remove('tw-hidden')
    // this.step2Target.style.display = 'block'
    // this.btnsubmitTarget.style.display = 'block'
    this.btnsubmitTarget.classList.remove('tw-hidden')
  }

}